<script lang="ts" setup name="G2oPublicLayout">
import FooterCopyright from '~/components/FooterCopyright.vue';
import G2OBrandPattern from '~/components/G2OBrandPattern.vue';
import LogoG2O from '~/components/LogoG2O.vue';
import LogoMYG2O from '~/components/LogoMYG2O.vue';

import type { IPublicLayoutHeaderLogo, IPublicLayoutVariant } from '~/types';

const { variant = 'primary', headerLogo = 'myg2' } = defineProps<{
  variant?: IPublicLayoutVariant;
  headerLogo?: IPublicLayoutHeaderLogo;
}>();
</script>

<template>
  <div
    class="flex h-full w-full flex-col justify-between"
    :class="{
      'bg-white': variant === 'primary',
      'bg-gray-100': variant === 'secondary',
    }"
  >
    <div
      class="flex h-full flex-col justify-between sm:m-8 lg:mx-auto lg:w-10/12 xl:w-8/12"
    >
      <div class="min-h-[90px]">
        <G2OBrandPattern />

        <div
          v-if="headerLogo !== 'none'"
          class="m-6 flex-shrink-0 sm:m-0 sm:flex sm:min-h-[90px] sm:items-center"
        >
          <RouterLink v-if="headerLogo === 'myg2'" :to="{ name: 'AuthLogin' }">
            <LogoMYG2O />
          </RouterLink>

          <a v-else href="https://g2ocean.com">
            <LogoG2O />
          </a>
        </div>
      </div>

      <div class="mx-2 my-4 flex-1 sm:mx-0 sm:my-0">
        <slot />
      </div>

      <div class="flex min-h-[90px] items-center gap-x-4">
        <LogoG2O class="h-08" />
        <div class="footerText flex items-center justify-between">
          <FooterCopyright />
        </div>
      </div>
    </div>
  </div>
</template>
